import type { LinkItem } from "../presentation/components";
import { FiHome } from "react-icons/fi";
import { MdContactMail } from "react-icons/md";
import { FaImages } from "react-icons/fa";

export const ROUTES = {
  home: "/",
  me: "/me",
  contact: "/contact",
  projects: "/projects",
  cover: "/cover",
};

export const resourcesLinks: LinkItem[] = [
  { name: "Me", link: ROUTES.me, icon: FiHome },
  { name: "Projects", link: ROUTES.projects, icon: FaImages },
  { name: "Contact", link: ROUTES.contact, icon: MdContactMail },
];
